import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { LiaArrowRightSolid } from "react-icons/lia";
import { Link } from 'react-router-dom';
import './button.scss';

export default function Button({ text, route }) {
    const isMediumScreen = useMediaQuery({ query: '(max-width: 850px)' });

    return (
        <Link className='button' style={{cursor: 'pointer', width: 'fit-content', fontSize: isMediumScreen ? '15px' : '20px', lineHeight: isMediumScreen ? '22px' : '28px', display: 'flex',padding: isMediumScreen ? '15px 16px' : '21px 24px', borderRadius: '100px', border: 'solid 1.6px #916859', alignItems: 'center' }}>
            <Link to={route}>{text}</Link>
            <LiaArrowRightSolid />
        </Link>
    )
}